import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchStandardsCustomScoreTypes } from '../../../requests/learning';
import { CustomScoreWrapper } from './StandardTypeSelector.styled';
import { DropdownSingle } from '../../../app/common/sharedComponents/DropdownSingle';
import { IDropdownOption } from '../../../app/@types/dropdown';

interface IStandardTypeSelectorProps {
  standardType: IDropdownOption | null;
  onChangeHandler: (option: IDropdownOption) => void;
}

const StandardTypeSelector = ({
  standardType,
  onChangeHandler,
}: IStandardTypeSelectorProps) => {
  const standarTypeArray = [standardType];
  const [customScoreTypes, setCustomScoreTypes] =
    useState<(IDropdownOption | null)[]>(standarTypeArray);
  const [defaultCustomedScore, setDefaultCustomedScore] =
    useState<IDropdownOption | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const { data } = await fetchStandardsCustomScoreTypes();
      if (!data) {
        setCustomScoreTypes(standarTypeArray);
        return;
      }
      const lqaStandardType = {
        value: t('COMMON.LEARNING.TITLES.LQA') as string,
        label: t('COMMON.LEARNING.TITLES.LQA_BENCHMARK') as string,
      };
      const convertedCustomScore: IDropdownOption[] = data.map((score) => ({
        value: `custom${score.customScoreNumber}`,
        label: score.customScoreName,
      }));
      convertedCustomScore.push(lqaStandardType);
      setCustomScoreTypes(convertedCustomScore);
      setDefaultCustomedScore(convertedCustomScore[0]);
      onChangeHandler(convertedCustomScore[0]);
    })();
  }, []);

  useEffect(() => {
    setDefaultCustomedScore(standardType);
  }, [standardType]);

  return (
    <>
      <div className="header-tag">
        <CustomScoreWrapper
          disabled={customScoreTypes && customScoreTypes.length === 0}
        >
          <DropdownSingle
            options={customScoreTypes as IDropdownOption[]}
            defaultOption={defaultCustomedScore}
            disabled={customScoreTypes && customScoreTypes.length === 0}
            callback={onChangeHandler}
            isClearable={false}
          />
        </CustomScoreWrapper>
      </div>
    </>
  );
};

export default StandardTypeSelector;
